__gh__webApp.weather.accuweather = {
	
	/**
	 * Show Alert Callback
	 */
	"showAlertCallback": function(options){
		var injectView 	= __gh__webApp.utilities.fetch.handlebarsView.append,
			json 		= ("json" in options) ? options.json : null,
			domain		= __gh__coreData.siteData.domain,
			callback 	= ("callback" in options) ? options.callback : null,
			baseURL		= __gh__coreData.siteData.baseURL,
			hasAlerts	= (json.success && json.items.length),
			title;
		
		if (!json.success || !hasAlerts){ 
			
			if (callback){
				callback();
			}
			
			return; 
		}
		
		title 	= json.items[0].title;
		title 	= (json.items.length > 1) ?  title + "..." : title;
		
		injectView({
			"dom"	: $("#content .alert")[0],
			"view"	: "alerts/default",
			"data"	:{
				"class"	: "alert-weather",
				"link"	: baseURL + "/section?template=weather_alert",
				"title"	: title,
				"icon"	: "fa-bolt"
			},
			"callback": callback			
		});
		
		
	},
	
	
	/**
	 * Shows the weather alert in the alert bar
	 */
	"showAlert": function(callback){
		var commonJS	= __gh__webApp.common,
			isEnabled	= commonJS.getObjectProperty(__gh__coreData["3rdPartyData"],"weather.accuweather.enableAlert"),
			fetchJSON 	= __gh__webApp.utilities.fetch.json.get,
			data		= (callback) ? {"callback":callback} : {},
			baseURL		= __gh__coreData.siteData.baseURL,
			feedURL		= baseURL + "/section/breaking_ajax?template=JSON_weatherAlert";
		
		if (!isEnabled) { 
			if (callback){
				callback();
			}
			return; 
		}
		
		var fetchOptions = {
			"async": true,
			"url": feedURL,
			"callbacks":[{"callback":"__gh__webApp.weather.accuweather.showAlertCallback","data":data}]
		};
		
		// If json would fail still run the callback if one was passed
		if (!commonJS.isObjectEmpty(data)){
			fetchOptions.errorCallbacks = [data];
		}
		
		fetchJSON(fetchOptions);
	}
};